import React, { useContext } from "react";
import { Fade } from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { illustration, greeting } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

async function handleResumeDownload(fallbackUrl) {
  try {
    const params = new URLSearchParams(window.location.search);
    const resumeId = params.get("resume_id") || params.get("resumeId");
    
console.log("Resume ID from URL:", resumeId);
    if (resumeId) {
      const cdnUrl = `https://cdn.anilgulati.com/${resumeId}`;
      const response = await fetch(cdnUrl);

      if (!response.ok) throw new Error(`CDN fetch failed: ${response.status}`);

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      const anchor = document.createElement("a");
      anchor.href = objectUrl;
      anchor.download = resumeId; // uses the filename from resume_id
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      URL.revokeObjectURL(objectUrl);
      return; // done — no fallback needed
    }
  } catch (err) {
    console.warn("Resume download via CDN failed, falling back.", err);
  }

  // Original flow: open resumeUrl in new tab
  if (fallbackUrl) {
    window.open(fallbackUrl, "_blank", "noopener,noreferrer");
  }
}

export default function Greeting() {
  const { isDark } = useContext(StyleContext);

  if (!greeting.displayGreeting) {
    return null;
  }

  const resumeUrl = greeting.resumeLink || greeting.cvLink;

  return (
    <Fade bottom duration={1000} distance="40px">
      <div
        className="greet-main"
        id="greeting"
        itemScope
        itemType="http://schema.org/Person"
      >
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                itemProp="name"
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              <p
                itemProp="description"
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="mailto:hi@anilgulati.com" />
                {resumeUrl && (
                  <div>
                    <a
                      className="main-button"
                      href={resumeUrl}
                      onClick={e => {
                        const params = new URLSearchParams(window.location.search);
                        if (params.get("resume_id") || params.get("resumeId")) {
                          e.preventDefault();
                          handleResumeDownload(resumeUrl);
                        }
                        // no resume_id → default href behaviour, no JS needed
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download Resume
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt="man sitting on table"
                src={require("../../assets/images/manOnTable.svg")}
              />
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}